// Each scan is a separate keyboard burst. Never retain a submitted or partial UID.
export class RfidScanner {
  private value = "";
  private lastAt = 0;
  reset() { this.value = ""; this.lastAt = 0; }
  key(key: string, now: number): string | null {
    if (now - this.lastAt > 750) this.value = "";
    this.lastAt = now;
    if (key === "Enter" || key === "Tab") {
      const uid = this.value.trim();
      this.reset();
      return uid || null;
    }
    if (key === "Escape") this.reset();
    else if (key.length === 1 && !/\s/.test(key)) {
      if (this.value.length >= 128) this.reset();
      this.value += key;
    }
    return null;
  }
}
